export default {"src":"/_next/static/media/clients.c5049413.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};